module.exports = function (obj, his_self) {
  //    let obj = {
  //      faction : faction ,
  //      moved_units : moved_units ,
  //      unmoved_units : unmoved_units ,
  //      destination_units : destination_units ,
  //      space : space ,
  //      from : from ,
  //      to : to ,
  //      max_formation_size : max_formation_size ,
  //    };

  if (!obj.to) {
    obj.to = 'Unknown';
  }
  var html = "<div class=\"movement-overlay\">\n    <div class=\"help\">\n\t<div class=\"movement-from\">".concat(obj.from, "</div> to <div class=\"movement-to\">").concat(obj.to, "</div></div>\n    <div class=\"available-units-overlay\"></div>\n    <div class=\"movement-table\"><div class=\"movement-source\">");
  for (var i = 0; i < obj.unmoved_units.length; i++) {
    console.log('UNMOVED: ' + JSON.stringify(obj.unmoved_units[i]));
    var ucss = '';
    var uclass = '';
    var utype = obj.unmoved_units[i].type;
    if (!obj.unmoved_units[i].navy_leader) {
      if (utype != 'navy_leader' && utype != 'regular' && utype != 'mercenary' && utype != 'cavalry' && obj.unmoved_units[i].reformer != true) {
        if (his_self.army[utype]) {
          uclass = 'army-unit';
          ucss = "background-image:url('/his/img/tiles/army/".concat(his_self.army[utype].img, "');background-size:cover;");
        }
      }
    }
    html += "\n\t     <div class=\"movement-unit option ".concat(uclass, " ").concat(obj.unmoved_units[i].type, "\" id=\"").concat(obj.unmoved_units[i].faction, "-").concat(obj.unmoved_units[i].idx, "\">\n\t       <div class=\"movement-unit-img\" style=\"").concat(ucss, "\"></div>\n\t       <div class=\"movement-unit-type\">").concat(obj.unmoved_units[i].type, "</div>\n\t       <div class=\"movement-type-faction\">").concat(obj.unmoved_units[i].faction, "</div>\n             </div>\n\t");
  }
  html += "</div>";
  html += "<div class=\"movement-destination\">";
  for (var _i = 0; _i < obj.destination_units.length; _i++) {
    var _ucss = '';
    var _uclass = '';
    var _utype = obj.destination_units[_i].type;
    if (_utype != 'regular' && _utype != 'mercenary' && _utype != 'cavalry') {
      _uclass = 'army-unit';
      _ucss = "background-image:url('/his/img/tiles/army/".concat(his_self.army[_utype].img, "');background-size:cover;");
    }
    html += "<div class=\"movement-unit immobile ".concat(_uclass, " ").concat(obj.destination_units[_i].type, "\" id=\"").concat(obj.destination_units[_i].faction, "-").concat(obj.destination_units[_i].idx, "\">\n\t       <div class=\"movement-unit-img\" style=\"").concat(_ucss, "\"></div>\n\t       <div class=\"movement-unit-type\">").concat(obj.destination_units[_i].type, "</div>\n\t       <div class=\"movement-type-faction\">").concat(obj.destination_units[_i].faction, "</div>\n            </div>");
  }
  for (var _i2 = 0; _i2 < obj.moved_units.length; _i2++) {
    var _ucss2 = '';
    var _uclass2 = '';
    var _utype2 = obj.moved_units[_i2].type;
    if (_utype2 != 'regular' && _utype2 != 'mercenary' && _utype2 != 'cavalry') {
      _uclass2 = 'army-unit';
      _ucss2 = "background-image:url('/his/img/tiles/army/".concat(his_self.army[_utype2].img, "');background-size:cover;");
    }
    html += "<div class=\"movement-unit option ".concat(_uclass2, " ").concat(obj.moved_units[_i2].type, "\" id=\"").concat(obj.moved_units[_i2].faction, "-").concat(obj.moved_units[_i2].idx, "\">\n\t       <div class=\"movement-unit-img\" style=\"").concat(_ucss2, "\"></div>\n\t       <div class=\"movement-unit-type\">").concat(obj.moved_units[_i2].type, "</div>\n\t       <div class=\"movement-type-faction\">").concat(obj.moved_units[_i2].faction, "</div>\n\t    </div>");
  }
  html += "</div></div><div class=\"movement-submit-button option\" id=\"end\">confirm and move</div></div>";
  return html;
};